import { render, staticRenderFns } from "./logisticsIntro.vue?vue&type=template&id=0179d4cd"
import script from "./logisticsIntro.vue?vue&type=script&lang=js"
export * from "./logisticsIntro.vue?vue&type=script&lang=js"
import style0 from "./logisticsIntro.vue?vue&type=style&index=0&id=0179d4cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports